module.exports = __webpack_public_path__ + "img/chadle_adv_25.c58a4132.png";